/* eslint-disable import/no-anonymous-default-export */
import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext,
} from 'react-admin';

import { UserEmpty } from './UserEmpty';
import { UserListContent } from './UserListContent';
import { UserListFilter } from './UserListFilter';

export const UserList = () => {
    const { identity } = useGetIdentity();

    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'DESC' }}
        >
            <UserListLayout />
        </ListBase>
    );
};

const UserListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const { identity } = useGetIdentity();

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (!identity || isPending) return null;

    if (!data?.length && !hasFilters) return <UserEmpty />;

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
            <UserListFilter />
            <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                <Title title={'Users'} />
                <ListToolbar actions={<UserListActions />} />
                <BulkActionsToolbar>
                    <BulkDeleteButton />
                </BulkActionsToolbar>
                <Card>
                    <UserListContent />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const UserListActions = () => (
    <TopToolbar>
        <SortButton fields={['id', 'name', 'email']} />
        <CreateButton
            variant="contained"
            label="New User"
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
